

































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import axios from "axios";
import {namespace} from "vuex-class";
import {cloneDeep} from "lodash";
import {SERVER_HOST_QR} from "@/config";
import DataSurvey from '@/components/lfs/NewStatistics/Elements/DataSurvey.vue';
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";
import BtnDefault from "@/components/UI/BtnDefault.vue";

const statistic_v4 = namespace('statistic_v4')

@Component({
  name: 'SurveyDashboard',
  components: {ErrorFetchingData, DataSurvey, BtnDefault}
})

export default class SurveyDashboard extends Vue {

  @statistic_v4.Getter('surveysFilled') protected surveysFilled: any
  @statistic_v4.Getter('surveysWithChecked') protected getSurveys: any
  @statistic_v4.Getter('loading') protected loading!: any
  @statistic_v4.Getter('error') protected error!: any
  @statistic_v4.Action('loadSurveysFromServer') protected loadSurveysFromServer!: any

  @Watch('getSurveys')
  onSurveysChanged(newVal: any) {
    this.surveys = cloneDeep(newVal)
    this.surveys = this.surveys.filter((item:any) => item.count != 0)
    if (Object.keys(this.currentSurvey).length) return
    if(this.surveys.length) {
      this.surveys[0].checked = true
      this.currentSurvey = this.surveys[0]
      this.fetchSurveyData()
    }
  }

  surveys: any[] = []
  currentSurvey: any = {}
  surveyLoading: boolean = true
  surveyError: boolean = false
  surveyFullInfo: any = {}

  checkSurvey(survey: any, idx: number) {
    survey.checked = true
    this.currentSurvey = survey
    this.surveys.forEach((survey: any) => survey.checked = false)
    this.surveys[idx].checked = true
    this.fetchSurveyData()
  }

  async fetchSurveyData() {
    this.surveyLoading = true
    this.surveyError = false
    try {
      const { data } = await axios.get(`${SERVER_HOST_QR}statistic/company/surveys/${this.currentSurvey.id}`)
      this.surveyFullInfo = data.data
      console.log('1',this.surveyFullInfo);
      this.surveyFullInfo.questions.map((el:any)=>{
        el.answers.sort((a:any,b:any)=>{
          return b.count - a.count
        })
        return el
      })
      console.log('2',this.surveyFullInfo);
    } catch (e) {
      console.log('boom')
      this.surveyError = true
    } finally {
      this.surveyLoading = false
    }
  }

  protected async mounted() {
    await this.loadSurveysFromServer()
  }
}
